import { defineMessages } from 'react-intl';

/** @internal */
export const notifyButtonTranslations = defineMessages({
  notifications: {
    defaultMessage: 'Notifications',
    id: 'GH0lEEpNg7HJ9sA6',
    description: 'Label text shown in the notify button trigger',
  },
  toggleOverlay: {
    defaultMessage: 'Toggle notify button notifications overlay',
    id: 'jishWwgadkdK/YkI',
    description: 'Aria label used for the notify button trigger',
  },
});
